import * as React from 'react';
import Popup from '../Popup';

export type Props = {
    showPopup: boolean,
    title?: string,
    customTextYesButton?: string;
    loading: boolean;
    loadingMessage?: string;
    shouldHideNoButton?: boolean;
    onCancel: () => void;
    executeFunction: () => void;
};

type State = {
    // user to check auto focus at the first time show popup
    firstLoading: boolean,
    isExecuted: boolean,
};

class PopupWarning extends React.Component<Props, State> {
    private comPopup: Popup;
    constructor(props: Props) {

        super(props);
        this.state = this.getInitialState();
    }

    getInitialState = (): State => {
        return {
            firstLoading: true,
            isExecuted: false,
        };
    }

    componentDidMount() {
        if (this.props.showPopup) {
            this.comPopup.open();
            this.setState({ isExecuted: false });
        }
    }

    componentDidUpdate() {
        if (this.props.showPopup && this.state.firstLoading) {
            this.setState({ firstLoading: false });
        }
    }

    componentWillReceiveProps(nextProps: Props) {
        if (nextProps.showPopup !== this.props.showPopup) {
            if (nextProps.showPopup) {
                this.comPopup.open();
                this.setState({ isExecuted: false });
            } else {
                this.comPopup.close();
                this.setState((prevState: State) => {
                    return {
                        ...prevState,
                        firstLoading: true
                    };
                });
            }
        }
    }

    onYesButtonClick = () => {
        if (!this.props.loading) {
            this.props.executeFunction();
            this.setState({ isExecuted: true });
        }
    }

    onEnterButtonPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            if (!this.props.loading) {
                this.props.executeFunction();
                this.setState({ isExecuted: true });
            }
        }
    }

    onClosePopup = () => {
        if (!this.props.loading) {
            this.props.onCancel();
        }
    }

    render() {
        const { loading, title, loadingMessage, shouldHideNoButton, customTextYesButton } = this.props;
        let textYesButton = customTextYesButton ? customTextYesButton : ' OK';
        return (
            <Popup
                ref={com => this.comPopup = com!}
                title={title ?? ''}
                close={this.onClosePopup}
                popupHidden={this.onClosePopup}
                extendClass=""
                footer={
                    <>
                        {
                            shouldHideNoButton && shouldHideNoButton
                                ? null
                                : <button id="btnCancelConfirmPopup" type="button" disabled={loading} style={{ marginRight: '10px' }} className="btn btn-sm btn-light" onClick={this.onClosePopup}>
                                    <i className="fa fa-times-circle" /> No</button>
                        }

                        <button id="btnYesConfirmPopup" type="button" disabled={loading} className={`btn btn-sm ${shouldHideNoButton ? 'btn-light' : 'btn-primary'}`} onClick={this.onYesButtonClick}>
                            <i className="fa fa-sign-in" />{textYesButton}
                        </button>
                    </>
                }
            >
                {
                    loading ?
                        <div className="form-group row loading-center">
                            <label className="col-auto col-form-label">{loadingMessage}</label>
                            <span className="spinner-border text-info" style={{ marginLeft: '155px' }} role="status" aria-hidden="true" />
                        </div>
                        :
                        <div className="form-group row">
                            <span className="col-auto col-form-label" style={{ color: '#333' }}>
                                Dear provider,
                                <br /><br />
                                The federal government and Surescripts require very strict verification of the provider ‘s personal information to register for E-Prescribing to ensure patient’s safety.
                                <br /><br />
                                <span style={{ fontWeight: 'bold' }}>Please fill in your personal information carefully.</span> The third-party Experian global information service company will not allow you to move forward with the registration process if they cannot verify your personal information.
                                <br /><br />
                                If Experian Company fails to verify your personal information three times, Experian will lock your name and will not let you to send in your personal information to them again in 30 days.
                            </span>
                        </div>

                }
            </Popup>
        );
    }
}

export default PopupWarning;


// WEBPACK FOOTER //
// ./src/components/shared/PopupWarning/PopupWarning.tsx